// extracted by mini-css-extract-plugin
module.exports = {"Card":"carousal_Card__37Hi_","ContainerDiv":"carousal_ContainerDiv__1x_no"};